import { render, staticRenderFns } from "./SortDropDownComponent.vue?vue&type=template&id=612adf56&"
import script from "./SortDropDownComponent.vue?vue&type=script&lang=ts&"
export * from "./SortDropDownComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports